/**
 * @file Renders the modal that adds a new organization public key.
 */

import React from "react";

import { CreateModal } from "@components/Page";
import { MODAL_WIDTH } from "@components/Constants";
import { createOrganizationPublicKeyOperation as operation } from "@api/services/identity";
import { type OrganizationPublicKey } from "@api/types";

import getCreateInputs from "./helpers/getCreateInputs";

const LABEL_TITLE = "Add Public Key";
const LABEL_SUBMIT = "Add";
const LABEL_ENTITY = "Public Key";

export type OrganizationPublicKeyCreateModalHandle = {
  open: () => void;
};

type Props = {
  modal: React.RefObject<
    OrganizationPublicKeyCreateModalHandle | Record<string, never>
  >;
  onSuccess: (createdPublicKey: OrganizationPublicKey) => void;
};

/**
 * Renders the modal form that creates an organization public key.
 */
const OrganizationPublicKeyCreateModal = ({
  modal,
  onSuccess,
}: Props): JSX.Element => {
  const inputs = getCreateInputs();
  const schema = operation.getSchema(inputs);

  const createModalProps = {
    title: LABEL_TITLE,
    entity: LABEL_ENTITY,
    submitLabel: LABEL_SUBMIT,
    width: MODAL_WIDTH,
    modal,
    schema,
    onSuccess,
    operation,
  };

  return (
    <CreateModal {...createModalProps} />
  );
};

export default OrganizationPublicKeyCreateModal;
